import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Baby, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { FadeIn, Button } from './Shared';
export const Hero = () => {
  return <section className="relative px-4 overflow-hidden py-8 md:py-12 pt-[10px] pb-[10px]" data-id="element-144">
      {/* Decorative stars */}
      <div className="absolute top-20 left-10 w-2 h-2 bg-gold-400 rounded-full opacity-50 blur-[1px]" data-id="element-145"></div>
      <div className="absolute top-40 right-20 w-3 h-3 bg-gold-400 rounded-full opacity-30 blur-[2px]" data-id="element-146"></div>

      <div className="max-w-6xl mx-auto text-center" data-id="element-147">
        <FadeIn data-id="element-148">
          <div className="inline-flex items-center space-x-2 text-gold-400 font-serif font-semibold tracking-wider uppercase text-xs mb-4" data-id="element-149">
            <span className="w-8 h-[1px] bg-gold-400" data-id="element-150"></span>
            <span data-id="element-151">MUNDO PRÁCTICO™</span>
            <span className="w-8 h-[1px] bg-gold-400" data-id="element-152"></span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-153">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-3" data-id="element-154">
            Todo lo que tu bebé <br className="hidden md:block" data-id="element-155" />
            necesita para dormir.
          </h1>
          <p className="text-xl md:text-2xl font-serif italic text-gold-400 mb-6" data-id="element-156">
            Listo. Desde esta noche.
          </p>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-157">
          <div className="relative max-w-4xl mx-auto mb-10" data-id="element-158">
            <div className="absolute inset-0 bg-gold-500/10 blur-[100px] rounded-full" data-id="element-159"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qsVK98fcc96DCxikAZdeEV/MockUp_Noches_de_Paz_(1).png" alt="MegaPack Noches de Paz" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-160" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-161">
          <p className="text-lg md:text-xl font-medium text-gray-200 mb-1" data-id="element-162">
            MegaPack Noches de Paz — Sistema Completo de Sueño Infantil
          </p>
          <p className="text-sm text-gray-400 mb-2" data-id="element-163">
            El sistema N°1 para padres con bebés en Argentina — 0 a 36 meses
          </p>
          <p className="text-sm text-gray-300 max-w-2xl mx-auto mb-8" data-id="element-164">
            Sin improvisar. Sin buscar. Sin más madrugadas sin saber qué hacer.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-165">
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-10 text-xs md:text-sm font-medium text-gray-300" data-id="element-166">
            <div className="flex items-center text-[10px]" data-id="element-167">
              <FileText className="w-4 h-4 mr-2 text-gold-400" data-id="element-168" /> 100% PDF
            </div>
            <div className="flex items-center text-[10px]" data-id="element-169">
              <Zap className="w-4 h-4 mr-2 text-gold-400" data-id="element-170" /> Acceso en 5 min
            </div>
            <div className="flex items-center text-[10px]" data-id="element-171">
              <Baby className="w-4 h-4 mr-2 text-gold-400" data-id="element-172" /> 0 a 36 meses
            </div>
            <div className="flex items-center text-[10px]" data-id="element-173">
              <ShieldCheck className="w-4 h-4 mr-2 text-gold-400" data-id="element-174" /> Garantía 7
              días
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-175">
          <Button href="#pricing" className="mb-6 w-full md:w-auto text-lg md:text-xl px-6 md:px-10 py-4 md:py-5" data-id="element-176">
            🌙 → QUIERO MI MEGAPACK AHORA
          </Button>
          <div className="flex items-center justify-center space-x-4 text-sm text-gray-400 mb-8" data-id="element-177">
            <span className="flex items-center" data-id="element-178">
              <Lock className="w-4 h-4 mr-1" data-id="element-179" /> Pago seguro
            </span>
            <span data-id="element-180">|</span>
            <span className="flex items-center" data-id="element-181">
              <CreditCard className="w-4 h-4 mr-1" data-id="element-182" /> Mercado Pago
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};